import { loader } from 'graphql.macro';

export const GET_PORTAL_USER_DEFAULT_PAYMENT_FREQUENCY = loader(
  './query.graphql'
);

export * from './types';
